import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0d3053"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-w-full tw-bg-[#F8FBFD] tw-border-[#DFDFDF] tw-border-solid tw-border-[1px] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }, null, -1))
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_5 = { class: "offer-attachments tw-grid tw-w-full" }
const _hoisted_6 = { class: "tw-rounded-[8.72px] tw-overflow-hidden tw-w-full tw-h-[94px]" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

import { ref, onMounted } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage, imageExtensions } from "@/core/utils/common";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { DisputeRequestStatusEnums } from "@/core/enums/ProjectsEnum";
import Button from "./ui/general/Button.vue";
import Text from "./ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewEvidenceAttachmentModal',
  props: {
  evidenceAttachment: {
    type: Object,
  },
},
  emits: [
  "on-close",
  "on-submit",
  "on-accept-offer",
  "on-reject-offer",
],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;
const internalInstance = getCurrentInstance();
const isLoading = ref<boolean>(false);

const isImageType = (publicURL: any) => {
  return imageExtensions.some((ext) => publicURL?.toLowerCase().endsWith(ext));
};

const ispdf = (attachments: any) => {
  return attachments?.publicURL?.toLowerCase().endsWith(".pdf");
};

const onClickBackButton = () => {
  return emits("on-close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    headerTitle: "View Evidence",
    width: "588px",
    isTitleStrong: true,
    borderRadius: "20px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Text, { variant: "h6" }, {
              default: _withCtx(() => [
                _createTextVNode("Attachment ")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (isImageType(props?.evidenceAttachment?.attachment))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: props.evidenceAttachment?.publicURL,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: props.evidenceAttachment?.publicURL || '',
                        alt: "Image",
                        class: "tw-w-full tw-h-full tw-object-cover"
                      }, null, 8, _hoisted_8)
                    ], 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: props.evidenceAttachment?.publicURL,
                      target: "_blank"
                    }, [
                      (ispdf(props.evidenceAttachment?.publicURL))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "tw-w-full tw-h-full tw-object-cover",
                            src: require('@/assets/icons/pdf-document-icon.svg'),
                            alt: "icon"
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "tw-w-full tw-h-full tw-object-cover",
                            src: require('@/assets/icons/documents.svg'),
                            alt: "icon"
                          }, null, 8, _hoisted_11))
                    ], 8, _hoisted_9))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})